import React, { useState } from "react";
import OrganComponent from "../../components/UI/OrganComponent";
import BodyComponent from "../../components/UI/BodyComponent";
import FormInputs from "../../components/UI/FormInputs"; // uses SelectListWithSearch inside
import FieldLoader from "../../components/UI/FieldLoader";
import Skeleton from "../../components/SkeletonComponent/Skeleton";

const HumanSystem = (props) => {
  const {
    visit_category,
    selectedBodyPart = [],
    handleEvent,
    setSelectedBodyPart,
    validation = {},
  } = props;
  // console.log("visitDetails",visitDetails.visit_category);

  const [organList, setOrganList] = useState([]);

  const handleDropdownChange = (val,isMulti,selected) => {    
    // let updatedParts = [...selectedBodyPart];
    // if (selected) {
    //   if (!updatedParts.includes(val)) {
    //     updatedParts.push(val);
    //   }
    // } else {
    //   updatedParts = updatedParts.filter((part) => part !== val);
    // }
  //   setSelectedBodyPart(prev => {
  //   let updated = [...prev];
  //   if (selected) {
  //     if (!updated.includes(val)) updated.push(val);
  //   } else {
  //     updated = updated.filter(part => part !== val);
  //   }
  //   return updated;
  // });
    handleEvent(val,selected)
    // const newArray = val ? val.split(",") : [];
    // const oldArray = Array.isArray(selectedBodyPart) ? selectedBodyPart : [];

    // const added = newArray.filter((item) => !oldArray.includes(item));
    // const removed = oldArray.filter((item) => !newArray.includes(item));
// console.log("updatedParts", updatedParts, selected);
    // updatedParts.forEach((item) => handleEvent(item, true));
    // removed.forEach((item) => handleEvent(item, false));
    // console.log("newArray",newArray);
    // setSelectedBodyPart(updatedParts);
  };

  return (
    <>
      <div className="row mb-3">
        <div className="col-12">
          <div className="form-group">
            <label className="text-sm text-truncate mb-0 opacity-75">
              Anatomical Regions
            </label>
            <FormInputs
              type="CheckboxDropDown"
              label="Organ Name"
              placeholder="Organ Name"
              className="form-control form-control-solid"
              name="organ_name"
              options={organList}
              value={selectedBodyPart}
              isMulti={1}
              changeHandler={(opt,ismulti,val)=>handleDropdownChange(opt.value,ismulti,val)}
            />
            {validation.organ_name && (
              <span className="text-danger m-1">{validation.organ_name}</span>
            )}
          </div>
        </div>
      </div>

      {visit_category ? (
        visit_category === "Urgent Care - Illness" ? (
          <OrganComponent
            onClick={handleEvent}
            editValue={selectedBodyPart}
            type="view"
            width="50%"
            setOrganList={setOrganList}
          />
        ) : (
          <div className="d-flex justify-content-center">
            <Skeleton
              onClick={handleEvent}
              editValue={selectedBodyPart}
              setOrganList={(val)=>setOrganList(val)}
            />
            {/* <BodyComponent
              view="back"
              type="view"
              width="50%"
              onClick={handleEvent}
              editValue={selectedBodyPart}
              setOrganList={setOrganList}
            /> */}
          </div>
        )
      ) : (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <FieldLoader isLoading={true} />
        </div>
      )}
    </>
  );
};

export default HumanSystem;
